import * as JSON from "util/json";
const StringUtils = {
  tempDocument: document.createElement("textarea"),
  capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  },
  escapeHTML(text) {
    this.tempDocument.textContent = text;
    return this.tempDocument.innerHTML;
  },
  unescapeHTML(text) {
    this.tempDocument.innerHTML = text;
    return this.tempDocument.textContent;
  },
  escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  },
  pluralize(number, singular, plural) {
    return number === 1 || number === "1" ? singular : plural;
  },
  stringify(text) {
    return (typeof text === "object" ? JSON.stringify(text) : String(text)) || "";
  },
  replaceSpaces(text, newCharacter = "-") {
    return text.replace(/\s/g, newCharacter);
  },
  toTitleCase(str, splitCharacter = " ") {
    return str.toLowerCase().split(splitCharacter).map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ");
  },
  truncateWithEllipses(text = "", maxLength = 10, end = "...") {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}${end}`;
    }
    return text;
  },
  getRecursiveChildText(reactNode) {
    if (typeof reactNode === "string") {
      return reactNode;
    }
    const { children } = (reactNode == null ? void 0 : reactNode.props) || {};
    if (Array.isArray(reactNode)) {
      const joinedNodes = [];
      reactNode.forEach((node) => {
        if (typeof node === "object") joinedNodes.push(StringUtils.getRecursiveChildText(node));
        else if (typeof node === "string") joinedNodes.push(node);
      });
      return joinedNodes.join(" ");
    }
    if (typeof children === "object") {
      return StringUtils.getRecursiveChildText(children);
    }
    if (typeof children === "string") {
      return children;
    }
    return "";
  }
};
export default StringUtils;
